<template>
    <v-stepper v-model="step">
        <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">Persyaratan</v-stepper-step>
            <v-stepper-step :complete="step > 2" step="2">Upload bukti persyaratan</v-stepper-step>
            <v-stepper-step step="3">Menunggu akun aktif</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
            <requirement-step
                @nextStep="step = 2"
                step="1"
            ></requirement-step>

            <proof-step
                @nextStep="step = 3"
                @prevStep="step = 1"
                step="2"
            ></proof-step>

            <post-waiting step="3"></post-waiting>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import ProofStep from './ProofStep'
import RequirementStep from './RequirementStep'
import PostWaiting from '@/components/dashboard/payment/PostWaiting'

export default {
    components: {
        PostWaiting,
        ProofStep,
        RequirementStep,
    },

    props: {
        payment: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            step: 1,
        }
    },

    created() {
        if (this.payment.payment_proof) {
            this.step = 3
        }
    }
}
</script>
